import { createGlobalStyle } from 'styled-components'
import globalStyles from 'shared/global-styles'

export default createGlobalStyle`
  ${globalStyles};
`
